import React, { useState } from "react";

import { LabelWithBackLine } from "../../../../../../components/LabelWithBackLine";
import { Table } from "./components/Table";
import useFetchData from "./helpers/fetchLogs";
import Loading from "../../../../../home/components/Loading";

export const LogsView = () => {
  const [page, setPage] = useState(1);

  const {
    data: item,
    isLoading,
    refetch,
  } = useFetchData({
    queryParams: {
      page,
      take: 10,
      order: "DESC",
    },
  });

  const handlePageChange = (event, value) => {
    refetch();
    setPage(value);
  };

  if (isLoading) return <Loading isLoading={isLoading} />;
  return (
    <>
      <LabelWithBackLine>Logs de processo</LabelWithBackLine>
      <Table.Root>
        <Table.Content>
          <Table.Head
            tableHeaders={[
              "Nº Autos processo",
              "Responsável ",
              "Tipo",
              "Observação",
              "Data de criação",
            ]}
          />
          <Table.Body logsList={item?.data ?? []} />
        </Table.Content>

        <Table.Pagination
          count={item?.meta?.pageCount ?? 0}
          page={item?.meta?.page ?? 1}
          hasPreviousPage={item?.meta?.hasPreviousPage ?? false}
          hasNextPage={item?.meta?.hasNextPage ?? false}
          onChange={handlePageChange}
        />
      </Table.Root>
    </>
  );
};

export default LogsView;
